import { render, staticRenderFns } from "./TariffsList.vue?vue&type=template&id=6f75cb40&"
import script from "./TariffsList.vue?vue&type=script&lang=js&"
export * from "./TariffsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports